module.exports = __webpack_public_path__ + "img/61TOP-ACQUA-U-RIC.GRECIA-RIC.LIMONEGONNA-VERMENTINO-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE1.22379fbf.jpg";